/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBcProductResponse } from '../../models/get-bc-product-response';

export interface GetBusinessCentralProductDetail$Params {
  id: number;
}

export function getBusinessCentralProductDetail(http: HttpClient, rootUrl: string, params: GetBusinessCentralProductDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBcProductResponse>> {
  const rb = new RequestBuilder(rootUrl, getBusinessCentralProductDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBcProductResponse>;
    })
  );
}

getBusinessCentralProductDetail.PATH = '/business-central/product/{id}';
